import { useCallback, useContext, useMemo } from 'react';
import { GameSessionContext } from '../../context-providers';
import type { GameSession } from '../../types/game-session.ts';

const factor = 10;
export const useGameSessionContext = () => {
  const { setContextItems, contextItems } = useContext(GameSessionContext);


  const setParams = useCallback((params: Partial<GameSession>) => {
    setContextItems(
      contextItems ? {
        ...contextItems,
        ...params,

      } : params);
  }, [contextItems, setContextItems]);

  const clearGameSessionContext = useCallback(() => {
    setContextItems({});
  }, [setContextItems]);


  const gameSessionParams = useMemo(() => {
    const output = {
      gameName: contextItems?.gameName,
      amount: contextItems?.amount,
      code: contextItems?.code ?? '',
      phoneNumber: contextItems?.phoneNumber ?? '',
      amountWithDiscount: contextItems?.amountWithDiscount,
      amountWithDiscountOrAmount: contextItems?.amountWithDiscount || contextItems?.amount,
    };
    return {
      ...output,
      isFreeTraining: !Boolean(output.amount),
      factor,
    };
  }, [contextItems]);

  return {
    setParams,
    gameSessionParams,
    clearGameSessionContext,
  };
};
